module.exports = __webpack_public_path__ + "static/media/amadeus-flag-bg.39502bc1.jpg";